export default __webpack_public_path__ + "static/duplicate-as-static-cohort-dark-mode-8e0d069787726caae5270d067223d8f9.png";